export default class homePage {
  constructor () {
    /*
    $(window).unbind('scroll').scroll(function(){
      let top = $(window).scrollTop();
      window.scrolling = true;
      if(top > 1){
        console.log('down');
        $(window).scrollTop(1);
        if(window.intro) window.intro.logo.velocityArr.unshift(10);
      } else if(top < 1) {
        console.log('up');
        $(window).scrollTop(1);
        if(window.intro) window.intro.logo.velocityArr.unshift(-10);
      }
      if(window.backgroundAnim) window.backgroundAnim.addSplashes();

      if(top!==1){
        if(window.intro) window.intro.logo.velocityArr.pop();
      }
    });
    */

    $('#damp').on('mousemove input', function(){
      let prc = $(this).val()/100;
      window.backgroundAnim.effectController.damp = 0.9 + (0.1 * prc);
      window.backgroundAnim.gui.updateDisplay();
      window.backgroundAnim.valuesChanger();
    });
    $('#mousesize').on('mousemove input', function(){
      let prc = $(this).val();
      window.backgroundAnim.effectController.mouseSize = prc;
      window.backgroundAnim.gui.updateDisplay();
      window.backgroundAnim.valuesChanger();
    });
    $('#lightstrength').on('mousemove input', function(){
      let prc = $(this).val()/100;
      window.backgroundAnim.effectController.lightStrength = 0.15 + (prc * .5);
      window.backgroundAnim.effectController.lightY = 40 + (100 * prc);

      window.backgroundAnim.gui.updateDisplay();
      window.backgroundAnim.valuesChanger();
    });
    $('#animspeed').on('mousemove input', function(){
      let prc = $(this).val();
      window.animSpeed = prc;
    });
    $('#view').on('toggle', function(){
      $('.wrap.home .home').toggle(200);
      $('div.tid').toggle(200);
      $('.nav').toggle(200);
    });
  }
}
